/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { UploadStrategy } from './UploadStrategy';
import {
    UploadStrategyFromJSON,
    UploadStrategyFromJSONTyped,
    UploadStrategyToJSON,
} from './UploadStrategy';

/**
 * 
 * @export
 * @interface StartAssetUploadResponseContent
 */
export interface StartAssetUploadResponseContent {
    /**
     * Stable identifier for the asset record.
     * @type {string}
     * @memberof StartAssetUploadResponseContent
     */
    assetId: string;
    /**
     * Identifier for this in-progress upload session.
     * @type {string}
     * @memberof StartAssetUploadResponseContent
     */
    uploadSessionId: string;
    /**
     * 
     * @type {UploadStrategy}
     * @memberof StartAssetUploadResponseContent
     */
    strategy: UploadStrategy;
    /**
     * The point in time after which issued URLs should be treated as expired.
     * @type {number}
     * @memberof StartAssetUploadResponseContent
     */
    expiresAt: number;
    /**
     * Present for single-part uploads.
     * @type {string}
     * @memberof StartAssetUploadResponseContent
     */
    uploadUrl?: string;
    /**
     * Present for multipart uploads.
     * @type {number}
     * @memberof StartAssetUploadResponseContent
     */
    multipartPartSizeBytes?: number;
    /**
     * Present for multipart uploads.
     * @type {number}
     * @memberof StartAssetUploadResponseContent
     */
    multipartPartCount?: number;
}


/**
 * Check if a given object implements the StartAssetUploadResponseContent interface.
 */
export function instanceOfStartAssetUploadResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetId" in value;
    isInstance = isInstance && "uploadSessionId" in value;
    isInstance = isInstance && "strategy" in value;
    isInstance = isInstance && "expiresAt" in value;
    return isInstance;
}

export function StartAssetUploadResponseContentFromJSON(json: any): StartAssetUploadResponseContent {
    return StartAssetUploadResponseContentFromJSONTyped(json, false);
}

export function StartAssetUploadResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartAssetUploadResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'assetId': json['assetId'],
        'uploadSessionId': json['uploadSessionId'],
        'strategy': UploadStrategyFromJSON(json['strategy']),
        'expiresAt': json['expiresAt'],
        'uploadUrl': !exists(json, 'uploadUrl') ? undefined : json['uploadUrl'],
        'multipartPartSizeBytes': !exists(json, 'multipartPartSizeBytes') ? undefined : json['multipartPartSizeBytes'],
        'multipartPartCount': !exists(json, 'multipartPartCount') ? undefined : json['multipartPartCount'],
    };
}

export function StartAssetUploadResponseContentToJSON(value?: StartAssetUploadResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'assetId': value.assetId,
        'uploadSessionId': value.uploadSessionId,
        'strategy': UploadStrategyToJSON(value.strategy),
        'expiresAt': value.expiresAt,
        'uploadUrl': value.uploadUrl,
        'multipartPartSizeBytes': value.multipartPartSizeBytes,
        'multipartPartCount': value.multipartPartCount,
    };
}

